export const GoBackButton = ({ onClick }) => (
  <button
    onClick={() => onClick(false)}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      backgroundColor: "white",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#374151",
      cursor: "pointer",
      transition: "all 0.2s ease",
    }}
  >
    <svg
      style={{ width: "16px", height: "16px" }}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 19l-7-7 7-7"
      />
    </svg>
    Go back
  </button>
);
